export default __webpack_public_path__ + "static/media/twitter.e7a19c03.svg";